import { NgModule } from "@angular/core";
import { ReversePipe } from "./array-reverse/reverse.pipe";
import { AudiencePipe } from "./audicence/audience";
import { CampaingPipe } from "./campaing/campaing";
import { CategoryPipe } from "./category/category";
import { CheckInPipe } from "./checkIn/checkIn";
import { ClientPipe } from "./client/client";
import { colorPipe } from "./color/color.pipe";
import { CountryPipe } from "./country/country";
import { MatchEventPipe } from "./event/match-event";
import { SubEventPipe } from "./event/sub-event";
import { FilterArrayPipe } from "./filter-array/filter-array.pipe";
import { FormPipe } from "./form/form";
import { GroupServicePipe } from "./group-service/group-service";
import { TruncatePipe } from "./limit/limit";
import { OrderByPipe } from "./order-by/order-by";
import { PollAnswersPipe } from "./poll/poll-answer";
import { PollAnswersQuestionPipe } from "./poll/poll-answer-question.";
import { sanitizeHtmlPipe } from "./sanizite/sanitize-html";
import { ServicePipe } from "./service/service";
import { ShopPipe } from "./shop/shop";
import { SponsorPipe } from "./sponsor/sponsor";
import { StaffPipe } from "./staff/staff";
import { CategorieStaffDataPipe } from "./staff/staffCategory";
import { TicketPipe } from "./ticket/ticket";
import { ToArrayPipe } from "./to-array/to-array";
import { TranslatePipe } from "./translate/translate";
import { UserStatsPipe } from "./user-stats/user-stats";
import { UserCheckDataPipe } from "./user/user-check";
import { UserDataPipe } from "./user/user-data";
import { UserInfoPipe } from "./user/user.info";
import { VotingAnswersPipe } from "./voting/voting-answer";
import { VotingAnswersQuestionPipe } from "./voting/voting-answer-question";
import { XlsApiPipe } from "./xls-api/xls-api";
import { XlsVarsPipe } from "./xls-api/xls_vars";

const PIPES = [
  TranslatePipe,
  SponsorPipe,
  OrderByPipe,
  StaffPipe,
  CategorieStaffDataPipe,
  ToArrayPipe,
  CategoryPipe,
  CheckInPipe,
  sanitizeHtmlPipe,
  TruncatePipe,
  SubEventPipe,
  XlsApiPipe,
  XlsVarsPipe,
  ClientPipe,
  UserStatsPipe,
  colorPipe,
  PollAnswersPipe,
  PollAnswersQuestionPipe,
  VotingAnswersPipe,
  VotingAnswersQuestionPipe,
  MatchEventPipe,
  FilterArrayPipe,
  UserDataPipe,
  UserCheckDataPipe,
  ShopPipe,
  CountryPipe,
  FormPipe,
  UserInfoPipe,
  GroupServicePipe,
  ServicePipe,
  TicketPipe,
  AudiencePipe,
  CampaingPipe,
  ReversePipe,
];
@NgModule({
  declarations: [...PIPES],
  exports: [...PIPES],
  imports: [],
})
export class PipesModule { }



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts